<template>
  <section-view :title="title" :tips="tips">
    <ul>
      <li v-for="(item, index) in list" :key="index">
        <b><i></i>{{item[titleKey]}}</b>
        <p>{{item[contentKey]}}</p>
      </li>
    </ul>
  </section-view>
</template>

<script>
  import SectionView from "@/components/SectionView";
  /**
   * 列表卡片
   */
  export default {
    name: "ListCard",
    components: {SectionView},

    props: {
      // 提示
      tips: {
        type: Boolean,
        default: false
      },
      // 标题
      title: {
        type: String,
        require: true
      },
      // 内容
      list: {
        type: Array,
        require: true
      },
      // 标题匹配项
      titleKey: {
        type: String,
        default: 'title'
      },
      // 内容匹配项
      contentKey: {
        type: String,
        default: 'content'
      }
    }
  }
</script>

<style lang="scss" scoped>
  ul {
    flex-direction: column;

    li {
      margin-bottom: 30px;

      b {
        height: 36px;
        font-size: 30px;
        font-weight: 500;
        color: #333333;
        display: flex;
        align-items: center;

        i {
          width: 31px;
          height: 31px;
          box-sizing: border-box;
          background: #ffffff;
          border: 11px solid #6CA0EC;
          border-radius: 50%;
          margin-right: 10px;
        }
      }

      p {
        font-size: 30px;
        color: #333333;
        line-height: 46px;
        text-align: justify;
        padding-top: 14px;
        white-space: pre-wrap;
      }

      :last-child {
        margin-bottom: 0;
      }
    }
  }
</style>